import { render, staticRenderFns } from "./GoBeyondInfo.vue?vue&type=template&id=052f1414&scoped=true"
import script from "./GoBeyondInfo.vue?vue&type=script&lang=js"
export * from "./GoBeyondInfo.vue?vue&type=script&lang=js"
import style0 from "./GoBeyondInfo.vue?vue&type=style&index=0&id=052f1414&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f1414",
  null
  
)

export default component.exports